import { useLazyQuery } from '@apollo/client';
import { SearchInput, SearchToolRoomResult } from '@bechtel/ht-types';
import { useCallback } from 'react';
import { GET_TOOL_ROOM } from '~/gql/tool-room';

export const useGetToolRooms = (fetchFromNetwork?: boolean) => {
  const [getToolRoomsQuery, { data, loading, error, refetch, networkStatus, fetchMore }] = useLazyQuery<
    {
      searchToolRooms: SearchToolRoomResult;
    },
    { searchInput: SearchInput }
  >(GET_TOOL_ROOM, {
    fetchPolicy: fetchFromNetwork ? 'network-only' : 'cache-first',
    notifyOnNetworkStatusChange: true,
  });
  const getToolRoomList = useCallback(
    (searchInput: SearchInput, onComplete?: (data) => void) => {
      getToolRoomsQuery({
        variables: {
          searchInput: {
            ...searchInput,
            paginationInput: {
              offset: 0,
              limit: 50,
            },
          },
        },
        notifyOnNetworkStatusChange: true,
        fetchPolicy: fetchFromNetwork ? 'network-only' : 'cache-first',
        onCompleted: (data) => {
          if (onComplete) {
            onComplete(data);
          }
        },
      });
    },
    [getToolRoomsQuery]
  );

  return { getToolRoomList, data, loading, error, refetch, networkStatus, fetchMore };
};
